'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './index.module.scss';
/** 検査結果 */
export const PdfResultHeaderLabel = (props) => {
    return (_jsxs("div", { className: styles.root, children: [_jsx("div", { className: styles.blank }), props.icon && props.cancer ? (_jsxs("div", { className: styles.label, children: [props.icon, props.cancer, "\u691C\u67FB\u7D50\u679C"] })) : (_jsx("div", { className: styles.blank }))] }));
};
export default PdfResultHeaderLabel;
//# sourceMappingURL=index.js.map